// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Increase specificity to ensure our css has higher priority as Leaflet also use !important */
.leaflet-control svg.leaflet-attribution-flag {
    display: none !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/Maps.css"],"names":[],"mappings":";AACA,8FAA8F;AAC9F;IACI,wBAAwB;AAC5B","sourcesContent":["\n/* Increase specificity to ensure our css has higher priority as Leaflet also use !important */\n.leaflet-control svg.leaflet-attribution-flag {\n    display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
